/* eslint-disable @typescript-eslint/naming-convention */
export enum ArticleStatusEnum {
    Draft = 'Draft',
    Scheduled = 'Scheduled',
    InReview = 'InReview',
    Failed = 'Failed',
    Posted = 'Posted',
    Retracted = 'Retracted',
    Rejected = 'Rejected'
}
